import { createSlice } from '@reduxjs/toolkit';

const initialState: ReportsState = {
    currentReport: {}
};

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        updateCurrentReport(state, action) {
            state.currentReport = action.payload;
        }
    }
});

export const { updateCurrentReport } = reportsSlice.actions;
export default reportsSlice.reducer;
